<template>
	<div class="container" ref="orderScreenshotRef">
		<ByDialog
			width="90%"
			v-model="isOpenFinishModal"
			title="您的訂單已成功送出到店家！"
			@cancel="closeFinishModal"
			@confirm="clickConfirm"
			@closeDialog="closeFinishModal"
			:noCancelButton="!showWhatsEatCoupon || !whatsEatSwitch"
			:cancelText="cancelText"
			cancel-button-style="main5"
			:confirmText="confirmText"
		>
			<template v-if="showWhatsEatCoupon && whatsEatSwitch">
				<h3 class="dialog-body-text" v-html="slotDialogBodyText"></h3>
				<ByCheckbox
					title="下次不要再顯示"
					width="auto"
					@change="disableWhatsEatShow"
				>
				</ByCheckbox>
			</template>
		</ByDialog>
		<ByDialog
			width="90%"
			v-model="isOpenFailModal"
			title="付款失敗！將重新回到點餐頁面。"
			@cancel="closeFailModal"
			@confirm="closeFailModal"
			:noCancelButton="true"
		>
		</ByDialog>
		<div class="center-page-minus">
			<div class="content-area">
				<span class="remind" v-if="canTake !== 'del'"
					>請保留此畫面，並於取餐時出示</span
				>
				<div
					class="num-wrap"
					v-if="canTake === 'stay'"
					:key="refreshKey + '-stay'"
				>
					<div class="num">
						<div class="title">取餐號碼</div>
						<div class="number">{{ data.takeNumber }}</div>
					</div>
					<div class="num">
						<div class="title">當前號碼</div>
						<div class="number">{{ takeNumber }}</div>
					</div>
				</div>

				<div class="num-wrap" v-else :key="refreshKey + '-default'">
					<div class="num">
						<div class="title">取餐號碼</div>
						<div class="number">{{ data.takeNumber }}</div>
					</div>
				</div>

				<div class="take-tip" v-if="canTake === 'take'">餐點完成，請取餐</div>
				<div class="take-tip" v-if="canTake === 'del'">你的餐點已被取消</div>
				<div class="information" ref="informationRef" @scroll="handleScroll">
					<div
						class="text"
						v-if="data.takeTime === null || data.orderStatus !== 1"
					>
						<p>訂單狀態</p>
						<p>{{ status }}</p>
					</div>
					<div class="text">
						<p>取餐方式</p>
						<p>{{ pickUpMethodType }}</p>
					</div>
					<div class="text" v-if="data.address !== ''">
						<p>外送</p>
						<p>{{ data.address }}</p>
					</div>
					<div class="text" v-if="data.name !== ''">
						<p>姓名</p>
						<p>{{ data.name }}</p>
					</div>
					<div class="text" v-if="data.phone !== ''">
						<p>電話</p>
						<p>{{ data.phone }}</p>
					</div>
					<div class="text">
						<p>付款狀態</p>
						<p :style="{ color: paidColor }">{{ paidText }}</p>
					</div>
					<div class="text">
						<p>付款金額</p>
						<p>${{ $stepPrice(data.amountReceived) }}</p>
					</div>
					<div class="text">
						<p>下單時間</p>
						<p>{{ data.createTime }}</p>
					</div>
					<div class="text" v-if="data.takeTime">
						<p v-if="data.address !== ''">外送時間</p>
						<p v-else>預約取餐時間</p>
						<p>{{ data.takeTime }}</p>
					</div>
					<!-- 滾動提示 -->
					<div class="scroll-hint" v-if="showScrollHint">
						<img
							class="scroll-arrow"
							src="@/assets/scroll-down.svg"
							alt="scroll down"
						/>
					</div>
				</div>
				<div class="foot-button-group">
					<ByButton stl="main2" @click="goBack">回我的訂單</ByButton>
					<ByButton
						v-if="showPartnerButton"
						:stl="hasCustomIcon ? '' : 'main6'"
						:class="{ 'custom-partner-btn': hasCustomIcon }"
						@click="goPartner"
					>
						<img
							alt="partner"
							:src="partnerInfo.icon"
							@error="handleIconError"
						/>
					</ByButton>
				</div>
			</div>
		</div>
		<ByFooter />
	</div>
</template>

<script>
import { emitter } from '@/utils/mitt'
import ByDialog from '@/components/Dialog.vue'
import ByCheckbox from '@/components/Checkbox.vue'
import ByButton from '@/components/Button.vue'
import ByFooter from '@/components/Footer.vue'

const orderStatus = {
	1: '新訂單',
	2: '製作中',
	3: '待取餐',
	4: '已完成',
	5: '取消訂單',
	6: '作廢',
	7: '待處理',
	101: '待確認',
	102: '付款失敗',
	103: '取消付款',
	104: '拒絕付款',
}

const STATUS_PENDING = 7
const STATUS_PAYMENT_MIN = 101 // 101~104 為金流交易狀態
const STATUS_PAYMENT_FAILED = 102

const payMethod = {
	CASH: '現金',
	LINE_PAY_ONLINE: 'LINE Pay',
	LINE_PAY_OFFLINE: 'LINE Pay',
	IPASS_ONLINE: 'iPASS TWQR',
	IPASS_OFFLINE: 'iPASS TWQR',
	PX_PAY_ONLINE: '全支付',
}

// 重連後重拉訂單的最小間隔（毫秒）
const RECONNECT_SYNC_INTERVAL = 10000

export default {
	components: { ByFooter, ByButton, ByCheckbox, ByDialog },
	data() {
		return {
			data: {
				userName: '',
				userPhone: '',
				paid: false,
				takeNumber: '',
				orderStatus: null,
				address: '',
				name: '',
				phone: '',
				amountReceived: 0,
				createTime: '',
				takeTime: null,
				paidStatus: false,
				payMethod: '',
				pickUpMethod: '',
				tableNumber: '',
				orderId: null,
			},
			refreshKey: Date.now(),
			isFailModal: false,
			isOpenFinishModal: false,
			showWhatsEatCoupon: true, //預設開啟
			isIOS: false,
			isAndroid: false,
			showScrollHint: false, // 控制滾動提示顯示
			iconLoadError: false, // 追蹤合作夥伴 icon 載入是否失敗
			lastReconnectSyncAt: 0, // 上次因重連而重拉訂單的時間
			reconnectSyncTimer: null,
		}
	},
	created() {
		emitter.on('TakeMeal_PAID', this.setPaid)
		this.setCouponShow()
		this.initFinishOrderDialog()
	},
	mounted() {
		this.getOrderInfo()
		this.isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
		this.isAndroid = /Android/i.test(navigator.userAgent)
	},
	beforeDestroy() {
		emitter.off('TakeMeal_PAID', this.setPaid)
		if (this.reconnectSyncTimer) {
			clearTimeout(this.reconnectSyncTimer)
			this.reconnectSyncTimer = null
		}
	},
	computed: {
		isOpenFailModal() {
			return this.isFailModal
		},
		paidText() {
			if (this.data.paidStatus) {
				const methodName =
					payMethod[this.data.payMethod] || this.data.payMethodName
				return '已付款(' + methodName + ')'
			}
			return '未付款'
		},
		paidColor() {
			if (this.data.paidStatus) {
				return '#000'
			}
			return '#FF1D00'
		},
		onWsWatchOrder() {
			return this.$store.state.socket.onWsWatchOrder
		},
		reconnectSeq() {
			return this.$store.state.socket.reconnectSeq
		},
		takeNumber() {
			return this.$store.state.takeMeal.takeNumber
		},
		canTakeNumberList() {
			return this.$store.state.takeMeal.canTakeNumberList
		},
		canTake() {
			if (this.data.orderStatus === 5 || this.data.orderStatus === 6) {
				return 'del'
			} else if (
				this.data.orderStatus === 3 ||
				this.data.orderStatus === 4 ||
				this.canTakeNumberList.includes(this.data.takeNumber)
			) {
				return 'take'
			} else {
				return 'stay'
			}
		},
		status() {
			return orderStatus[this.data.orderStatus]
		},
		pickUpMethodType() {
			const pickUpMethod = this.data.pickUpMethod
			if (pickUpMethod === 'DINE_IN') {
				const tableNumber = this.data.tableNumber
				if (tableNumber && tableNumber !== '') {
					return '內用(' + tableNumber + '桌)'
				}
				return '內用'
			} else if (pickUpMethod === 'DELIVERY') {
				return '外送'
			} else if (pickUpMethod === 'DELIVERY_PLATFORM') {
				return '外送平台'
			}

			return '外帶自取'
		},
		// WhatsEat平台開關
		whatsEatSwitch() {
			return this.$store.state.store.openInfo?.whatsEatSwitch
		},
		// WhatsEat的優惠卷數量
		whatsEatCouponAmount() {
			return this.$store.state.store.whatsEatCouponAmount
		},
		slotDialogBodyText() {
			// 根據是否發行優惠卷及數量更動視窗文字
			let _text = `未來也可以透過 <br/>	吃什麼App線上點餐喔!`
			if (this.whatsEatCouponAmount && this.whatsEatCouponAmount > 0) {
				// 確保數量是安全的數字
				const safeAmount = parseInt(this.whatsEatCouponAmount, 10) || 0
				_text = `目前有 ${safeAmount} 張優惠卷可領取 <br/> 是否前往領取?`
			}
			return _text
		},
		confirmText() {
			let _text = '確認'
			if (this.whatsEatSwitch && this.showWhatsEatCoupon) {
				_text = '前往查看'
			} else if (
				this.whatsEatCouponAmount &&
				this.whatsEatCouponAmount.length > 1
			) {
				_text = '前往領取'
			}
			return _text
		},
		cancelText() {
			return '暫不需要'
		},
		partnerInfo() {
			const partner = this.$store.state.store.platformInfo?.partner

			const defaults = {
				enabled: true,
				url: 'https://supr.link/fH3HM',
				icon: require('@/assets/partner.svg'),
			}

			// 判斷 icon 來源
			let icon = defaults.icon
			if (partner?.icon && partner.icon !== '') {
				// 有設定值，檢查是否載入失敗
				icon = this.iconLoadError
					? require('@/assets/load-img1.png')
					: partner.icon
			}

			return {
				enabled: partner?.enabled ?? defaults.enabled,
				url: partner?.url || defaults.url,
				icon: icon,
			}
		},
		showPartnerButton() {
			return this.partnerInfo.enabled
		},
		hasCustomIcon() {
			// 若 icon 不等於預設值且不是錯誤回退圖片，代表是自訂 icon
			const defaultIcon = require('@/assets/partner.svg')
			const fallbackIcon = require('@/assets/load-img1.png')
			const currentIcon = this.partnerInfo.icon
			return currentIcon !== defaultIcon && currentIcon !== fallbackIcon
		},
	},
	watch: {
		onWsWatchOrder({ orderId, orderStatus }) {
			if (this.data?.orderId === orderId) {
				this.data.orderStatus = orderStatus
				if (
					orderStatus === STATUS_PENDING ||
					orderStatus >= STATUS_PAYMENT_MIN
				) {
					return
				}
				this.refreshKey = Date.now()

				if (orderStatus > 3) {
					const index = this.$store.state.myOrder.list.findIndex(
						e => e.orderId === orderId,
					)
					if (index > -1) this.$store.state.myOrder.list.splice(index, 1)
					this.$router.push(`/${this.$route.params.random}/MyOrder`)
				}
			}
		},
		canTake(q, o) {
			if (q === 'take' && o !== 'take') {
				this.vibrate()
			}
		},
		// 重連成功：後端不會補推斷線期間的狀態變更，需自行重拉訂單詳情
		reconnectSeq() {
			this.scheduleReconnectSync()
		},
	},
	methods: {
		// 僅在有 WhatsEat 優惠券推廣時才顯示訂單完成 Dialog，否則直接清除狀態
		initFinishOrderDialog() {
			const finishOrder = this.$store.state.myOrder.finishOrder
			if (!finishOrder) return

			if (this.showWhatsEatCoupon && this.whatsEatSwitch) {
				this.isOpenFinishModal = true
			} else {
				this.$store.commit('myOrder/SET_FINISH_ORDER', false)
			}
		},
		clickConfirm() {
			if (this.whatsEatSwitch && this.showWhatsEatCoupon) {
				this.goWhatsEatShop()
			}
			this.$store.commit('myOrder/SET_FINISH_ORDER', false)
			// 手動關閉data狀態
			this.isOpenFinishModal = false
		},
		closeFinishModal() {
			this.$store.commit('myOrder/SET_FINISH_ORDER', false)
			// 手動關閉data狀態
			this.isOpenFinishModal = false
		},
		closeFailModal() {
			this.isFailModal = false
			this.$router.replace(`/${this.$route.params.random}/Store`)
		},
		vibrate() {
			navigator.vibrate =
				navigator.vibrate ||
				navigator.webkitVibrate ||
				navigator.mozVibrate ||
				navigator.msVibrate
			if (navigator.vibrate) {
				navigator.vibrate(1000)
			}
		},
		goBack() {
			this.$router.push(`/${this.$route.params.random}/MyOrder`)
		},
		setPaid({ id, paidStatus }) {
			if (this.data.orderId === id) {
				this.data.paidStatus = paidStatus
			}
		},
		// 重連後重拉訂單：首次立即執行，窗口內的後續重連合併成一次在窗口尾端補打。
		// 網路抖動時連線一成功 errorCount 就歸零（見 socket 模組），退避不會升階、
		// 重連可每 1.5~3 秒觸發一次，不節流會對後端連續打同一支。
		// 合併而非丟棄 —— 丟掉最後一次會讓畫面永遠停在舊狀態。
		scheduleReconnectSync() {
			if (this.reconnectSyncTimer) {
				return
			}
			const wait = Math.max(
				0,
				RECONNECT_SYNC_INTERVAL - (Date.now() - this.lastReconnectSyncAt),
			)
			this.reconnectSyncTimer = setTimeout(() => {
				this.reconnectSyncTimer = null
				this.lastReconnectSyncAt = Date.now()
				this.getOrderInfo({ silent: true })
			}, wait)
		},
		// silent：重連後的背景重同步，不蓋全屏 loading，失敗也不打斷畫面（維持現有狀態）
		async getOrderInfo({ silent = false } = {}) {
			let id = null
			let hashId = null
			const orderId = this.$route.params.OrderId
			if (!isNaN(Number(orderId))) {
				//舊注單 id為Integer
				id = orderId
			} else if (orderId.length === 36) {
				//新注單 id為UUID
				id = orderId
			} else {
				hashId = orderId
			}
			try {
				// 使用全域 Loading（僅 loading 模式，全屏）
				if (!silent) {
					this.$loading.loading('載入訂單資訊...')
				}

				const res = await this.$api.order.getOrderInfo({
					orderId: id,
					hashId: hashId,
				})

				const orderStatus = res.data.orderStatus
				if (orderStatus === STATUS_PAYMENT_FAILED) {
					// 金流付款失敗 =>  彈窗+導到菜單
					this.isFailModal = true
					return
				}

				this.data = res.data
				this.$store.commit('takeMeal/SET_TAKE_NUMBER', res.data.maxTakeNumber)
				this.$store.commit(
					'takeMeal/SET_TAKE_NUMBER_LIST',
					res.data.canTakeNumberList,
				)
				// 檢查訂單資訊是否需要滾動
				this.checkScrollable()
			} catch (error) {
				if (silent) {
					// 重連後的背景同步失敗：保留現有畫面，等下次推播或重連再更新
					$devLog('[TakeMeal] 重連後同步訂單失敗，維持現有畫面', error)
					return
				}
				console.error('載入取餐資訊失敗:', error)
				this.$alert('獲取訂單詳情失敗!', 'danger')
				await this.$router.replace(`/${this.$route.params.random}/Store`)
			} finally {
				if (!silent) {
					this.$loading.done()
				}
			}
		},
		disableWhatsEatShow(value) {
			// 禁用WhatsEat優惠卷提示
			this.$store.commit('user/SET_SHOW_WHATS_EAT_COUPON', !value)
		},
		goPartner() {
			window.open(this.partnerInfo.url)
		},
		handleIconError() {
			this.iconLoadError = true
		},
		goWhatsEatShop() {
			const shopId = this.$store.state.store.whatsEatShopId
			let url = `https://www.whatseat.com.tw/download?shopId=${shopId}`
			if (!this.isIOS && !this.isAndroid) {
				url = 'https://www.whatseat.com.tw'
			}
			window.open(url)
		},
		setCouponShow() {
			// 需要深拷貝紀錄初始的顯示狀態 避免勾選按鈕影響視窗行為
			this.showWhatsEatCoupon = Boolean(
				this.$store.state.user.showWhatsEatCoupon,
			) //全域狀態可變，組件data不變
		},
		checkScrollable() {
			// 檢查訂單資訊是否可滾動
			this.$nextTick(() => {
				const el = this.$refs.informationRef
				if (el) {
					this.showScrollHint = el.scrollHeight > el.clientHeight
				}
			})
		},
		handleScroll(event) {
			// 監聽滾動事件，接近底部時隱藏提示
			const el = event.target
			const scrollBottom = el.scrollHeight - el.scrollTop - el.clientHeight
			// 距離底部小於 10px 時隱藏提示
			if (scrollBottom < 10) {
				this.showScrollHint = false
			}
		},
	},
}
</script>

<style lang="sass" scoped>
%title
	font-size: 18px
	font-weight: bold
	margin-top: 10px

.dialog-body-text
	font-size: 18px
	margin: 8px 0 5px 0

.by-checkbox
	justify-content: center
	margin: 10px 0 15px 0
	font-size: 15px

.container
	height: 93vh
	display: flex
	flex-direction: column
	overflow: hidden
	position: relative

	.center-page-minus
		text-align: center
		flex: 1
		display: flex
		flex-direction: column
		overflow: hidden

		.content-area
			position: relative
			flex: 1
			display: flex
			flex-direction: column
			overflow: hidden

		.btn
			border-radius: 50px
			height: 45px
			font-size: 17px
			width: 50%
			margin-top: 20px

		.by-input
			margin-bottom: 15px

		.remind
			display: block
			margin: 20px auto 0
			font-size: 16px
			border: 2px solid #ababab
			padding: 7px
			border-radius: 5px
			width: 90%
			color: red
			flex-shrink: 0

		.information
			position: relative
			flex: 1
			min-height: 0
			overflow-y: auto
			margin-top: 15px
			background-color: #f3f3f3
			padding: 0 20px
			border-radius: 10px

			.scroll-hint
				position: absolute
				bottom: 0
				left: 0
				right: 0
				height: 50px
				background: linear-gradient(to bottom, transparent, rgba(243, 243, 243, 0.95))
				display: flex
				align-items: center
				justify-content: center
				pointer-events: none
				border-radius: 0 0 10px 10px

			.scroll-arrow
				width: 32px
				height: 32px
				animation: floatUpDown 1.5s ease-in-out infinite

		.text
			display: flex
			justify-content: space-between
			padding: 20px 0

			&:not(:nth-last-child(1))
				border-bottom: 1px solid #D8D8D8

			p:nth-child(2)
				font-weight: bold

		.foot-button-group
			flex-shrink: 0
			display: flex
			justify-content: space-evenly
			padding: 15px 0

			.btn
				width: 45%

	::v-deep .flex
		+fc
		position: absolute
		bottom: 5px
		flex-wrap: wrap
		width: calc(100% - 40px)
		transform: translateX(20px)

		> div
			width: 100%

.num-wrap
	display: flex
	align-items: flex-start
	justify-content: space-between
	width: 300px
	margin: 12px auto 0
	flex-shrink: 0

.num
	flex: 1

	.title
		@extend %title

	.number
		font-size: 50px
		color: #FF1D00
		font-weight: bold
		margin-top: 10px
		min-height: 50px

.take-tip
	@extend %title
	margin: 36px auto 24px
	flex-shrink: 0

.button
	display: flex
	align-items: center

	& > :first-child
		margin-right: 15px

// 滾動提示箭頭浮動動畫
@keyframes floatUpDown
	0%, 100%
		transform: translateY(0)
	50%
		transform: translateY(-5px)

// 自訂合作夥伴按鈕（有設定 icon 時，背景透明）
.custom-partner-btn
	background: transparent !important
	img
		width: 100%
		height: 100%
		object-fit: contain
</style>
